import baseApi from "./base-api";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8080/";

function updateDefaultText(data) {
    return baseApi.put(`px-settings`, data);
}

function getDefaultText() {
    return baseApi.get(`px-settings`);
}

const pxSettingsService = {
    updateDefaultText: updateDefaultText,
    getDefaultText: getDefaultText,
};

export default pxSettingsService;